import { StorageResourceLocation } from '../../data/specialized/storage/storage.location';
import { interpolate } from '../../functions/interpolate.function';
import { ReadonlyCollectionRepository } from '../abstraction';
import { Dictionary } from '../../types/dictionary';
import { StorageDataAccess } from '../../data-access/abstraction/storage.data-access';

export class ReadonlyStorageCollectionRepository<TItem, TParams> implements ReadonlyCollectionRepository<TItem[], TParams> {

  constructor(protected dataAccess: StorageDataAccess,
              protected key: string) { }

  async load(params: TParams): Promise<TItem[]> {
    const location: StorageResourceLocation = {
      key: this.getKey(params)
    };
    const result = this.dataAccess.get<Dictionary<TItem>>(location);
    const items = Object.values(result ?? {})
      .filter(o => !!o)
      .map(o  => o as TItem);
    return items;
  }

  protected getKey(params: TParams): string {
    return interpolate(this.key, params ?? {});
  }
}
